import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n'
import App from './App.tsx'
import './lib/chartConfig' // Import Chart.js configuration globally

// Suppress external script errors that don't affect the app
window.addEventListener('error', (event) => {
  // Ignore errors from external scripts/extensions
  if (event.filename && (
    event.filename.includes('onboarding.js') ||
    event.filename.includes('extension://') ||
    !event.filename.includes(window.location.origin)
  )) {
    event.preventDefault()
    console.warn('Suppressed external script error:', event.message)
    return false
  }
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
